import { useIsMobile } from '@noor/lib';
import type { ModalRenderProps } from '@noor/lib';
import { BranchModalDesktop } from './branch-modal.desktop';
import { BranchSheetMobile } from './branch-sheet.mobile';

type BranchModalProps = ModalRenderProps<'add-branch'> | ModalRenderProps<'edit-branch'>;

/**
 * Add / edit branch, registered under `add-branch` / `edit-branch`.
 *
 * Picks between two distinct trees, mirroring the page-level `.mobile.tsx`
 * split (CLAUDE.md §6c): mobile is a full-screen native-app takeover with a
 * single column of fields (Figma 26614:20465), where desktop is a centered
 * 880px sheet pairing them two-per-row. Both branches share the same schema,
 * defaults/mappers and mutation hooks — only the view differs.
 */
export function BranchModal(props: BranchModalProps) {
  return useIsMobile() ? (
    <BranchSheetMobile {...props} />
  ) : (
    <BranchModalDesktop {...props} />
  );
}
